import { createAsyncThunk } from "@reduxjs/toolkit";

import { errorToast, loadingToast, successToast } from "@/component/toasts";
import {
  createShiftPasscode,
  deleteShiftPasscode,
  getShiftPasscode,
  updateShiftPasscode,
} from "@/services/staff/shift-passcodes";

export const getShiftPasscodesAsync = createAsyncThunk(
  "staff/getShiftPasscodes",
  async (data: Record<string, number>) => {
    try {
      const response = await getShiftPasscode(data);
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);

export const createShiftPasscodeAsync = createAsyncThunk(
  "staff/createShiftPasscode",
  async (data: any) => {
    let response;
    try {
      response = await createShiftPasscode(data);
      successToast("Shift Passcode created successfully");
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);

export const updateShiftPasscodeAsync = createAsyncThunk(
  "staff/updateShiftPasscode",
  async (data: any) => {
    let response;
    loadingToast("Updating Shift Passcode");
    try {
      response = await updateShiftPasscode(data.id, data);
      successToast("Shift Passcode updated successfully");
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);

export const deleteShiftPasscodeAsync = createAsyncThunk(
  "staff/deleteShiftPasscode",
  async (id: string) => {
    let response;
    loadingToast("Deleting Shift Passcode");
    try {
      response = await deleteShiftPasscode(id);
      successToast("Shift Passcode deleted successfully");
      return response.data;
    } catch (error: any) {
      errorToast(error?.response?.data?.message);
      throw new Error("Failed to fetch data");
    }
  }
);
